import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./templates.css";
import { config } from "../config";
import FullScreenLoader from "../components/FullScreenLoader";
import LeftPanel from "../components/leftPanel";
import { Helmet } from "react-helmet-async";
import { addRecentTemplate, getRecentTemplates } from "../components/recentTemplates";
const slugify = (text) => {
  return text
    .replace(/\.[^/.]+$/, "")
    .replace(/[_\s]+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .toLowerCase();
};

const Templates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [recentTemplates, setRecentTemplates] = useState([]);
  const handleBackClick = () => {
    navigate(-1);
  };
 
  useEffect(() => {
    setRecentTemplates(getRecentTemplates());
  }, []);

 
  useEffect(() => {
    fetch(`${config.baseURL}/get_templates.php`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => setTemplates(data.templates || []))
      .catch((err) => navigate("/dashboard"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <FullScreenLoader />;
  if (error) return <p>Error: {error}</p>;
  if (templates.length === 0) return <p>No templates found.</p>;

  return (
    <>
      <Helmet key="landing">
      <title>
    Download Legal Templates in DOCX Format | Contracts, NDAs, Agreements & More
  </title>

  <meta
    name="description"
    content="Access professionally written legal templates in DOCX format including Contracts, NDAs, Lease Agreements, Wills, and Privacy Policies. Download editable and lawyer-approved documents instantly from LegalDocumentGenerator.com."
  />

  <meta
    name="keywords"
    content="download legal templates, legal document templates docx, employment contract download, NDA template docx, lease agreement word format, will and testament docx, divorce agreement template, business contracts download, freelance agreement word, marriage contract docx, privacy policy word format, rental agreement download, statement of work docx, partnership agreement template, website terms and conditions download, editable legal forms"
  />

  <link rel="canonical" href="https://legaldocumentgenerator.com/templates" />
            </Helmet>
      <div className="create_background">
        <LeftPanel />
        <div className="create_main">
          <div className="templates_title">
            <img src={config.Backbutton} alt="back" onClick={handleBackClick} />
            Templates
          </div>

          <div className="recommanded">
           <label >Recommanded Templates</label>
           <div className="recommandedTemplates">
            <img className="recommandedTemplatesImg" src={config.leaseRecommanded} alt="Lease" onClick={() => navigate(`/templates/lease-agreement-ai-legal`)}/>
            <img className="recommandedTemplatesImg" src={config.mutualRecommanded} alt="Mutual NDA" onClick={() => navigate(`/templates/mutual-nda-ai-legal`)} />
            <img className="recommandedTemplatesImg" src={config.divorceRecommanded} alt="Divorce Seperation Aggrement" onClick={() => navigate(`/templates/divorce-separation-agreement-ai-legal`)} />
            <img className="recommandedTemplatesImg" src={config.marriageRecommanded} alt="Marriage Aggrement" onClick={() => navigate(`/templates/marriage-agreement-ai-legal`)} />
           </div>

          </div>

          {recentTemplates.length > 0 && (
  <div className="recommanded">
    <label>Recently Viewed</label>
    <div className="recommandedTemplates">
      {recentTemplates.map((tpl) => (
        <div key={tpl.slug} className="recentTemplates">
        <div >
          <img
            className="recentTemplatesImg"
            src={tpl.img}
            alt={tpl.name}
            onClick={() => navigate(`/templates/${tpl.slug}`)}
          />
          <div style={{ fontSize: "0.9rem", marginTop: "5px" }}>{tpl.name}</div>
        </div>
        </div>
      ))}
    </div>
  </div>
)}          
           <div className="recommanded">
            <label>All Templates</label>
          <div className="template-grid">          
            {templates.map((tpl, index) => {
              const slug = slugify(tpl.template_name);
              const imgSrc = config[`templatesdefault${index % 3}`];
              return (
                <div
                  key={tpl.template_name}
                  className="template-card"
                  onClick={() => {
                    addRecentTemplate({
                      name: tpl.template_name.replace(/_/g, " ").replace(/\.docx$/, ""),
                      slug,
                      img: imgSrc
                    });
                    navigate(`/templates/${slug}`);
                  }}
                >
                  <img src={imgSrc} alt="Doc Preview" />
                  <div className="template-name">
                    {tpl.template_name
                      .replace(/_/g, " ")
                      .replace(/\.docx$/, "")}
                  </div>
                </div>
              );
            })}
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Templates;
